import { render, staticRenderFns } from "./AcoustoOpticNotice.vue?vue&type=template&id=003076db&scoped=true&"
import script from "./AcoustoOpticNotice.vue?vue&type=script&lang=js&"
export * from "./AcoustoOpticNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003076db",
  null
  
)

export default component.exports